// useUserStore.ts
import { useAtom } from 'jotai';
import {
  userDataAtom,
  userLoadingAtom,
  userErrorAtom,
  userStateAtom,
  setUserLoadingAtom,
  setUserErrorAtom,
  clearUserDataAtom,
} from '../store/userStore';
import { IUserRootResponse } from '../types/user';

export const useUserStore = () => {
  const [userData, setUserData] = useAtom(userDataAtom);
  const [loading, setLoading] = useAtom(userLoadingAtom);
  const [error, setError] = useAtom(userErrorAtom);
  const [userState] = useAtom(userStateAtom);
  const [, setUserLoading] = useAtom(setUserLoadingAtom);
  const [, setUserError] = useAtom(setUserErrorAtom);
  const [, clearUserData] = useAtom(clearUserDataAtom);

  const updateUserData = (data: IUserRootResponse | null) => {
    setUserData(data);
  };

  const updateLoading = (isLoading: boolean) => {
    setUserLoading(isLoading);
  };

  const updateError = (errorMessage: string | null) => {
    setUserError(errorMessage);
  };

  const clearData = () => {
    clearUserData();
  };

  return {
    // State
    userData,
    loading,
    error,
    userState,
    
    // Actions
    updateUserData,
    updateLoading,
    updateError,
    clearData,
  };
};
